import { useEffect, useState } from 'react';

import { SearchIcon } from '@/components/Icons';

import { InputWithIcon } from './InputWithIcon';

type SearchInputProps = {
    searchValue: string;
    setSearchValue: (value: string) => void;
    searchPlaceholder: string;
    className?: string;
    id?: string;
    isSearchPending?: boolean;
};
export const SearchInput = ({
    searchValue,
    setSearchValue,
    searchPlaceholder,
    className,
    id,
    isSearchPending,
}: SearchInputProps) => {
    const [currentInputValue, setCurrentInputValue] = useState(searchValue);

    useEffect(() => {
        setCurrentInputValue(searchValue);
    }, [searchValue]);

    return (
        <InputWithIcon
            value={currentInputValue}
            onInputChange={setCurrentInputValue}
            onSearch={setSearchValue} // setSearchValue is the function that actually triggers the search
            isSearchPending={isSearchPending}
            className={className}
            icon={<SearchIcon variant="action" />}
            placeholder={searchPlaceholder}
            id={id}
        />
    );
};
